import React from 'react';
import CloseIcon from '../Icons/Action/CloseIcon';
interface CloseButtonProps {
  className?: string;
  fill?: string;
  onClose: () => void;
}
const CloseButton: React.FC<CloseButtonProps> = ({
  onClose,
  className,
  fill = 'white'
}) => {
  return <div className={`bg-[rgba(255,255,255,0.50)] p-2.5 rounded-full cursor-pointer ${className}`} onClick={onClose} data-sentry-component="CloseButton" data-sentry-source-file="CloseButton.tsx">
      <CloseIcon className="" fill={fill} data-sentry-element="CloseIcon" data-sentry-source-file="CloseButton.tsx" />
    </div>;
};
export default CloseButton;